import { OAuthServiceType } from "@common/constants";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { useQuickbooksConnectionCreationMutation } from "@api/quickbooks.api";
import { didRequestReachServer } from "@api/apiError";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useOAuthPopup } from "@hooks/useOAuthPopup";

interface UseConnectQuickbooksOptions {
    entityId?: number;
    workspaceId?: string;
    connectionId?: string;
    onSuccess?: (connection: IntegrationConnection) => void;
}

export function useConnectQuickbooks({
    entityId,
    workspaceId,
    connectionId,
    onSuccess,
}: UseConnectQuickbooksOptions) {
    const { error: toastError } = useToaster();
    const mutation = useQuickbooksConnectionCreationMutation(
        onSuccess,
        workspaceId,
    );

    const { open: connect, isPopupOpen } = useOAuthPopup({
        service: OAuthServiceType.QUICKBOOKS,
        serviceLabel: "QuickBooks",
        onAuthorized: ({ code, additionalParams }) =>
            mutation.mutate(
                {
                    authCode: code,
                    realmId: additionalParams.realmId,
                    entityId,
                    connectionId,
                },
                {
                    onError: (error) => {
                        if (!didRequestReachServer(error)) {
                            toastError(
                                "Couldn't connect to QuickBooks. Try again.",
                            );
                        }
                    },
                },
            ),
    });

    return { connect, isPending: isPopupOpen || mutation.isPending };
}
